import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box, Image } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import { useSeasonalLogo } from '../../../../components/seasonal/use-seasonal-logo';
import logo from '../../assets/images/bonusly-logo.png';
import { AppPath } from '../../config/router';

export const CompanyLogo: FC = () => {
	const company = useCurrentCompany();
	const { t } = useTranslation('vertical_navbar');
	const { logoUrl: seasonalLogo } = useSeasonalLogo();

	// Determine which logo to use: seasonal > company > default
	const logoConfig = useMemo(() => {
		const logoSrc = seasonalLogo || company?.logo_url || logo;
		const logoAlt = seasonalLogo
			? t('admin_menu.company_logo', { name: 'Bonusly 🎃' })
			: company?.logo_url
				? t('admin_menu.company_logo', { name: company.name })
				: t('admin_menu.company_logo', { name: 'Bonusly' });

		return { logoSrc, logoAlt };
	}, [seasonalLogo, company?.logo_url, company?.name, t]);

	return (
		<Box as={Link} id="primary-nav-logo" data-testid="company-logo" to={AppPath.Home} px={6} py={3.5} display="flex" justifyContent="center">
			<Image data-testid="logo-image" alt={logoConfig.logoAlt} objectFit="contain" src={logoConfig.logoSrc} maxH={20} />
		</Box>
	);
};
